import React from 'react';
import heroEmblem from '../assets/images/hero-emblem.svg';
import { AppLink } from '../routing';

const heroVideo = '/harlan-bw.mp4';

export function HomePage() {
  return (
    <section id="home" className="hero">
      <div className="hero-stage">
        <video className="hero-video" autoPlay playsInline muted loop>
          <source src={heroVideo} type="video/mp4" />
        </video>
        <div className="hero-overlay" />
        <div className="hero-grain" aria-hidden="true" />

        <div className="hero-brand">
          <img className="hero-emblem" src={heroEmblem} alt="" aria-hidden="true" />
          <h1 className="hero-title">
            <img className="hero-logo" src="/H-logo-w.png" alt="Harlan" />
          </h1>
          <p className="hero-tagline">Country as good as it once was.</p>
          <p className="hero-sub">Modern honky tonk · 90&apos;s attitude · Northern California</p>
        </div>

        <div className="hero-actions">
          <AppLink className="hero-btn" href="/shows">
            Upcoming Shows
          </AppLink>
          <AppLink className="hero-btn" href="/contact">
            Book the Band
          </AppLink>
          <AppLink className="hero-btn" href="/epk">
            View EPK
          </AppLink>
        </div>

        <div className="hero-slider" aria-hidden="true">
          <span className="slider-pause">❚❚</span>
          <div className="slider-dots">
            <span className="slider-dot active" />
            <span className="slider-dot" />
            <span className="slider-dot" />
          </div>
        </div>
      </div>

      <div className="hero-details">
        <div className="hero-card">
          <p className="eyebrow">Where We Play</p>
          <h3>Festivals · Clubs · Corporate · Fairs</h3>
          <p className="meta">Flexible sets from 30–120 mins · turnkey PA &amp; lighting available</p>
        </div>
        <div className="hero-card">
          <p className="eyebrow">Sound</p>
          <h3>&rsquo;90s country, modern hits, and originals with edge</h3>
          <p className="meta">Garth · Strait · Brooks &amp; Dunn · Morgan Wallen</p>
        </div>
        <div className="hero-card">
          <p className="eyebrow">Advancing</p>
          <h3>Pro stage plots, easy settlement</h3>
          <p className="meta">We make the promoter&rsquo;s life simple.</p>
        </div>
      </div>
    </section>
  );
}
